import Vue from 'vue';
import Vuex from 'vuex';
import 'babel-polyfill';

import storeActionItems from './action-items/x-action-items';
import storeEmployer from './employer/x-employer';
import storeEmployerContacts from './employer/x-employer-contacts';
import storeEmployerOprs from './employer/x-employer-oprs';
import storeCards from './participant/x-cards';
import storeParticipant from './participant/x-participant';
import storeDependents from './participant/x-dependents';
import storeSession from './framework/utils/session-store';
import storePermissions from "./framework/utils/x-permissions";
import storeRecent from "./framework/utils/x-recent";
import storeRoute from "./framework/utils/x-route";
import storeAccounts from './accounts/x-accounts';
import storeAccount from './accounts/x-account';
import storePlans from './plans/x-plans';
import storePlan from './plans/x-plan';
import storePlanDocument from './plans/x-plan-document';
import storeTransactions from './transactions/x-transactions';
import storeTransaction from './transactions/x-transaction';
import storePartner from './partner/x-partner';
import storeAgency from './agency/x-agency';
import storeBroker from './broker/x-broker';
import storeUsers from './user/x-users';
import storeUser from './user/x-user';
import storeUserProfile from './user/x-user-profile';
import storeNotes from './note/x-notes';
import storeDocRecords from  './docRecord/x-doc-record';
import storeLookups from  './framework/utils/x-lookups';
import storeCobraConfig from './cobra/x-cobra-config';
import storeCobraPlans from './cobra/x-cobra-plans';
import storeCobraRates from './cobra/x-cobra-rates';
import storeCobraOrder from './cobra/x-cobra-order';
import storeChangeTracker from './framework/utils/x-change-tracker';
import storeNachas from './finance/x-nachas';
import storeEmployerEdi from './edi/x-employer-edi';
import storeProgress from './framework/x-progress';
import storeGuidance from './guidance/x-guidance';
import { extendStoreModules } from './framework/utils/store-utils';
import storeBenefitsPlans from './newCobra/x-benefits-plans';
import storeCobraEvents from './cobra/x-cobra-election-events';
import storeAbTesting from './ab-testing/x-ab-tests';
import storeCobraParticipant from './cobra/x-cobra-participant';

Vue.use(Vuex);

const modules = {
    actionItems: storeActionItems,
    employer: storeEmployer,
    cards: storeCards,
    participant: storeParticipant,
    dependents: storeDependents,
    session: storeSession,
    permissions: storePermissions,
    recent: storeRecent,
    route: storeRoute,
    plans: storePlans,
    plan: storePlan,
    planDocument: storePlanDocument,
    accounts: storeAccounts,
    account: storeAccount,
    transactions: storeTransactions,
    transaction: storeTransaction,
    partner: storePartner,
    agency: storeAgency,
    broker: storeBroker,
    users: storeUsers,
    user: storeUser,
    userProfile: storeUserProfile,
    notes: storeNotes,
    docRecords: storeDocRecords,
    lookups: storeLookups,
    cobraConfig: storeCobraConfig,
    cobraPlans: storeCobraPlans,
    cobraRates: storeCobraRates,
    cobraOrder: storeCobraOrder,
    cobraEvents: storeCobraEvents,
    cobraParticipant: storeCobraParticipant,
    changeTracker: storeChangeTracker,
    nachas: storeNachas,
    contacts: storeEmployerContacts,
    oprs: storeEmployerOprs,
    employerEdi: storeEmployerEdi,
    progress: storeProgress,
    guidance: storeGuidance,
    benefitsPlans: storeBenefitsPlans,
    abTesting: storeAbTesting
};

extendStoreModules(modules);

const store = new Vuex.Store({
    modules: modules,
    state: {
    },
    methods: {
    },
    actions: {
    },
    mutations: {
    }
});

_.values(modules).forEach(m => {
    if (m.init) m.init(store);
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js